export default function Scene() {
  return (
    <>
      <p align="left">
        <a class="1" href="/">
          main
        </a>
        {' > '}
        <a class="1" href="/art">
          art
        </a>
        {' > '}
        <a class="1" href="/photos/">
          photography
        </a>
        {' > '}
        <a class="1" href="/photos/people">
          people
        </a>
      </p>
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/1of7hills.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/1of7hills_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />1 of 7 Hills
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/acropolis.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/acropolis_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Acropolis
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/bridgei.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/bridgei_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Bridge I
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/bridgeii.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/bridgeii_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Bridge II
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/bridgeiii.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/bridgeiii_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Bridge III
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/bridgeiv.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/bridgeiv_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Bridge IV
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/bridgev.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/bridgev_sm.jpg"
                  width="82"
                  height="200"
                />
                <br />
                Bridge V
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a
                href="/assets/photo/scene/closedatnight-noon.jpg"
                target="_blank"
              >
                <img
                  id="1"
                  src="/assets/photo/scene/closedatnight-noon_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Closed
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/coveredstation.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/coveredstation_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Covered Station
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/cow.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/cow_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Cow
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/crossingthetejo.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/crossingthetejo_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Crossing the Tejo
              </a>{' '}
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/devorzhum.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/devorzhum_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Devorzhum
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/fountainofyouth.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/fountainofyouth_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Fountain of Youth
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/gardenofeden.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/gardenofeden_sm.jpg"
                  width="118"
                  height="200"
                />
                <br />
                Garden of Eden
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/ghostfield.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/ghostfield_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Ghost Field
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a
                href="/assets/photo/scene/guardingupaboveinthekeep.jpg"
                target="_blank"
              >
                <img
                  id="1"
                  src="/assets/photo/scene/guardingupaboveinthekeep_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Guarding the Keep
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/house13.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/house13_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                House 13
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a
                href="/assets/photo/scene/justchillingbellow.jpg"
                target="_blank"
              >
                <img
                  id="1"
                  src="/assets/photo/scene/justchillingbellow_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Just Chillin' Below
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a
                href="/assets/photo/scene/justhangingabove.jpg"
                target="_blank"
              >
                <img
                  id="1"
                  src="/assets/photo/scene/justhangingabove_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Just Hangin' Above
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/lisbonbynight.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/lisbonbynight_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Lisbon at Night
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/livingdome.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/livingdome_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Living Dome
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/lookingtotejo.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/lookingtotejo_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Looking to Tejo
              </a>{' '}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/morningside.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/morningside_sm.jpg"
                  width="112"
                  height="200"
                />
                <br />
                Morning Side
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/mourningcandle.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/mourningcandle_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Mourning Candle
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/nierika.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/nierika_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Nierika
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/nightvegetation.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/nightvegetation_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Night Vegetation
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/nutchest.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/nutchest_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Nutchest
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/onfirebaby.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/onfirebaby_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                On Fire. Baby!
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/partofnature.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/partofnature_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Part of Nature
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a
                href="/assets/photo/scene/passoutonexistance.jpg"
                target="_blank"
              >
                <img
                  id="1"
                  src="/assets/photo/scene/passoutonexistance_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Pass out on Existance
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/railroad.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/railroad_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Railroad
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a
                href="/assets/photo/scene/redflowerinthebackyard.jpg"
                target="_blank"
              >
                <img
                  id="1"
                  src="/assets/photo/scene/redflowerinthebackyard_sm.jpg"
                  width="200"
                  height="87"
                />
                <br />
                Red Flower
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/requiescatinpax.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/requiescatinpax_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Requiscat in Pax
              </a>{' '}
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/rustedskylight.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/rustedskylight_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Rusted Skylight
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/sex.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/sex_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                SEX
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/shouldiclimbit.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/shouldiclimbit_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Should I Climb It
              </a>{' '}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a
                href="/assets/photo/scene/sittingonthemountain.jpg"
                target="_blank"
              >
                <img
                  id="1"
                  src="/assets/photo/scene/sittingonthemountain_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Sitting on the Mountain
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a
                href="/assets/photo/scene/stairsimmortalityundead.jpg"
                target="_blank"
              >
                <img
                  id="1"
                  src="/assets/photo/scene/stairsimmortalityundead_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Stairs Immortality Undead
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/thecrane.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/thecrane_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                The Crane
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/thepathhome.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/thepathhome_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                The Path Home
              </a>{' '}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a
                href="/assets/photo/scene/thethreefoldteach.jpg"
                target="_blank"
              >
                <img
                  id="1"
                  src="/assets/photo/scene/thethreefoldteach_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Threefold Teach
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/timeto...jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/timeto.._sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Time to...
              </a>{' '}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a
                href="/assets/photo/scene/tryingtotamenature.jpg"
                target="_blank"
              >
                <img
                  id="1"
                  src="/assets/photo/scene/tryingtotamenature_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Trying to Tame Nature
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a
                href="/assets/photo/scene/ulisses-ii-thefleet.jpg"
                target="_blank"
              >
                <img
                  id="1"
                  src="/assets/photo/scene/ulisses-ii-thefleet_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Ulisses I - The Fleet
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a
                href="/assets/photo/scene/ulisses-i-theheritage.jpg"
                target="_blank"
              >
                <img
                  id="1"
                  src="/assets/photo/scene/ulisses-i-theheritage_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Ulisses II - the Heritage
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/scene/villagedoor.jpg" target="_blank">
                <img
                  id="1"
                  src="/assets/photo/scene/villagedoor_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Village Door
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a
                href="/assets/photo/scene/waitingtoleave01.jpg"
                target="_blank"
              >
                <img
                  id="1"
                  src="/assets/photo/scene/waitingtoleave01_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Waiting to Leave I
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a
                href="/assets/photo/scene/waitingtoleave02.jpg"
                target="_blank"
              >
                <img
                  id="1"
                  src="/assets/photo/scene/waitingtoleave02_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Waiting to Leave II
              </a>
            </div>
          </td>
        </tr>
      </table>
    </>
  );
}
